var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(i){return _c('div',{key:i},[_c('div',{on:{"click":function($event){return _vm.goRoom(i)}}},[_vm._v("进入房间--->"+_vm._s(i))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }